module.exports = __webpack_public_path__ + "static/bg-happy_hockey-e6b5454e6a8e1d46069cd44c5d33f122.jpg";